export default __webpack_public_path__ + "445988cbea4de104e154cc12a749308b.png";